import React from 'react';

const EmptyColumn = () => {
  return <div></div>;
};

export default EmptyColumn;
